export default {
    viewPlanOrder: {
        planOrder: {
            customer: {
                firmName: '',
                firmBrokerTreeNodeId: -1,
                agentName: '',
                agentId: -1,
                agentBrokerTreeNodeId: -1
            }
        },
        availableStories: [],
        annotation: null,
        products: [],
        planUserFirms: [],
        planEditors: [],
        deliveredPlanOrder: null,
        compareStoreys: []
    }
};
